import { useSelector } from "react-redux";
import { getNhDealApplicationId } from "features/authSlice";
import { useGetloanOfficerQuery } from "pages/application/applicationService";

export const useLoanOfficer = () => {
    const nhDealApplicationId = useSelector(getNhDealApplicationId);
    const { data: loanOfficerDetails } = useGetloanOfficerQuery(
        nhDealApplicationId,
        { skip: !nhDealApplicationId }
    );
    
    return loanOfficerDetails;
};
